import * as Config from '../../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import './core.css';
import '../../../Library.css'; /* Global App */
import './main.css';

import CustomDragLayerWrapper from '../../dnd/CustomDragLayerWrapper';
import ModalWrapper from '../../modal/ModalWrapper';
import PreviewWrapper from '../../preview/PreviewWrapper';
import ErrorWrapper from '../../error/ErrorWrapper';
import TooltipWrapper from '../../tooltip/TooltipWrapper';

import LearnEnv from './mode/learn/LearnEnv';
import PlayEnv from './mode/play/PlayEnv';

import MainRoute from './MainRoute';

import { setLinkage } from "../../../../actions/index";

function ConnectedLibrary({
  backend, maxWidth, maxHeight, fullHeight, playerCoordinates, style,
  active, mode
}) {
  const dispatch = useDispatch();
  const msTouchDelay = (navigator.userAgent.match(/Tablet|iPad|Mobile|Windows Phone/i)) ? 1000 : 0;

  useEffect(() => {
    if (!localStorage.getItem('fl')) {
      localStorage.setItem('fl', false);
    }
    dispatch(setLinkage((mode === 'play')));
    if (mode === 'play' || !mode) { window.sidebar_toggle && window.sidebar_toggle(); }
  }, [mode, dispatch])

  return active ? (
    <DndProvider backend={ backend === `touch` ? TouchBackend : HTML5Backend } options={{ enableTouchEvents: true, enableMouseEvents: true, /* enableHoverOutsideTarget: true, (remove v14+) */ delay: msTouchDelay }}>
      <div id="library" style={style} className={`bp-library flexRow bpc ${fullHeight && `fullHeight`} ${Config.API_NAME} `}>
        <MainRoute />

        { (mode === 'learn' || mode === null) && <LearnEnv maxWidth={maxWidth} maxHeight={maxHeight} fullHeight={fullHeight} playerCoordinates={playerCoordinates} />  }
        { mode === 'play' && <PlayEnv maxWidth={maxWidth} maxHeight={maxHeight} fullHeight={fullHeight} playerCoordinates={playerCoordinates} />  }

        <CustomDragLayerWrapper layer={`custom_drag_layer`} />
        <ModalWrapper height={playerCoordinates.height + 80} />
        <PreviewWrapper />
        <ErrorWrapper />
        <TooltipWrapper />
      </div>
    </DndProvider>
  ) : null;
}

ConnectedLibrary.propTypes = {
  backend: PropTypes.string.isRequired,
  maxWidth: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  playerCoordinates: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
  active: PropTypes.bool,
  mode: PropTypes.string,
}

const Library = connect(
  state => ({
    active: !!state.api,
    mode: state.IMode
  })
)(ConnectedLibrary);

export default Library;
